/**************************************************
 * Nombre:       Formulario_Inter_Area
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {School} from "@mui/icons-material";
import {NEGRITA, OFERTAACADEMICA} from "../../Constantes";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Formulario_Inter_Area = ({...props}) => {
    const {sCell} = useResponsive()

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 0}}>
                    <Typography sx={{fontSize: sCell ? 32 : 38, fontFamily: NEGRITA, fontWeight: 600, lineHeight: 1.1}}>
                        Escoge tu area de aprendizaje
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400}}>
                        de a cuerdo a tu area de aprendizaje estaras vinculado a una escuela de aprendizaje donde
                        gozaras de beneficios en tu formacion academica y laboral
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={School} nombre={'Escuela de aprendizaje (Area de conocimiento)'} dato={'escuela'} {...props}
                                   opciones={OFERTAACADEMICA.map((it) => it.nombre)}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Inter_Area